import $api from "@http";

const BASE = "/api/v1/doctor_profiles";

export default class DoctorsService {
  static async getDoctors({page, size, search, sort, with_archived}) {
    const params = new URLSearchParams();
    if (page != null) params.append("page", page);
    if (size != null) params.append("page_size", size);
    if (search) params.append("q[name_cont]", search);
    if (sort?.value && sort?.direction) {
      params.append("q[s][]", `${sort.value} ${sort.direction}`);
    }
    if (with_archived != null) params.append("with_archived", with_archived);

    return $api.get(`${BASE}?${params.toString()}`);
  }

  static async viewDoctor({id}) {
    return $api.get(`${BASE}/${id}`);
  }

  static async createDoctor({doctor}) {
    return $api.post(BASE, {doctor_profile: doctor});
  }

  static async archiveDoctor({id}) {
    return $api.post(`${BASE}/${id}/archive`);
  }

  static async unArchiveDoctor({id}) {
    return $api.post(`${BASE}/${id}/restore`);
  }

  static async deleteDoctor({id}) {
    return $api.delete(`${BASE}/${id}`);
  }
}
